import {
  Component,
  ElementRef,
  OnInit,
  TemplateRef,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TechnicianService } from '../../services/technician.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { OperatorExecutionService } from 'src/app/services/operator-execution.service';
import { ManagerExecutionService } from '../../services/manager.service';
import { PrevConfigurationService } from 'src/app/services/prev-configuration.service';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import * as moment from 'moment';
import { AgGridAngular } from 'ag-grid-angular';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { BaseApi } from 'src/backend/api/base-api';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { TechScoreService } from 'src/app/services/tech-score.service';
import { prevTaskService } from 'src/app/services/prev-task.service';
import { Subscription } from 'rxjs';
import { ActionEditDeleteBtnRendererTechnicianSubTask } from 'src/app/action-edit-delete-btn-renderer-technician-sub-task.component';
import { ExternalVendorRendererComponent } from 'src/app/external-vendor-renderer.component';
import { TechnicianRendererComponent } from 'src/app/technician-renderer.component';
import { UserConfigurationsService } from 'src/app/services/user-configurations.service';
import { type } from 'os';

@Component({
  selector: 'app-technician-execution',
  templateUrl: './technician-execution.component.html',
  styleUrls: ['./technician-execution.component.scss'],
})
export class TechnicianExecutionComponent implements OnInit {
  @ViewChild('agGrid') agGrid!: AgGridAngular;
  subTaskForm: FormGroup;
  subTasksArray: any[] = [];
  isEdit: boolean = false;
  technicianForm: any;
  imageFile: any;
  imageFileName: any;
  ImageUrl: string = '';
  blobStorageUrl: string = '';
  isStatus: boolean = true;
  isSparePartsYes: boolean = false;
  spinnerText: string = '';
  scode: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs!: any[];
  rowData: any[] | any = [];
  isPending: boolean = false;
  frameworkComponents: any;
  gridOptions: any = {
    defaultColDef: {
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true,
      filter: 'agSetColumnFilter',
    },
    context: {
      componentParent: this,
    },
    suppressCellSelection: true,
  };
  isSubTaskSaved: boolean = false;
  subtaskFormMode: boolean = true; // True for add, false for edit
  isViewMode: boolean = false;
  technician: any = {
    // LineArea: '', operExecWO: '', WOStatus: '', WOStatusDisplay: '', WOType: '', FailureMode: '', Priority: '', StartTime: new Date(), CompleteTime: '', SpareParts: '', SparePartCode: '', SPRequestTime: '', SPReceivedTime: '', Remark: '', AfterPicture: [], Remarks: '', TechnicianId: '', CreatedAt: '', CreatedBy: 0, ID: 0,OpCreatedAt:'', MachineBreakdown: ''
    LineArea: '',
    operExecWO: '',
    WOStatus: '',
    WOStatusDisplay: '',
    WOType: '',
    FailureMode: '',
    Priority: '',
    StartTime: '',
    CompleteTime: '',
    SpareParts: '',
    SparePartCode: '',
    SPRequestTime: '',
    SPReceivedTime: '',
    Remark: '',
    AfterPicture: [],
    Remarks: '',
    TechnicianId: '',
    CreatedAt: '',
    CreatedBy: 0,
    ID: 0,
    OpCreatedAt: '',
    MachineBreakdown: '',
  };
  PriorityList: any = [];
  vendorToggle: boolean = false;
  breadcrumList!: any;
  @ViewChild('technicianimageViewModal')
  private technicianimageViewModal!: TemplateRef<any>;
  @ViewChild('operatorimageViewModal')
  private operatorimageViewModal!: TemplateRef<any>;
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('subTaskDialog') private subTaskDialog!: TemplateRef<any>;
  isviewMode: any;
  spReqTime: any;
  spRecTime: any;
  vendorMode: 'existing' | 'new' = 'existing';
  filteredTechnicianList: any[] | any = [];
  vendorsList: any[] = [];
  disableStartTime: boolean;
  get f() {
    return this.technicianForm.controls;
  }
  imageSrc = new Array<string>();
  fileType: any;
  FileData: any = [];
  FileList: any = [];
  EditFileData: any = [];
  OperatorFiles: any = [];
  woType: any = [];
  failMode: any = [];
  userList: any = [];
  technicianList: any = [];
  Group: any;
  Plant: any;
  permisson!: any;
  languageDir = 'ltr';
  langObj: any = {};
  technicians: any[] | any = [];
  moduleId!: any;
  plantCode: any;
  pageId!: any;
  isAccess = ApplicationPermission.TECHNITOIN_EXECUTION_LIST_ACCESS;
  isWrite = ApplicationPermission.TECHNITOIN_EXECUTION_LIST_CREATE;
  isDelete = ApplicationPermission.TECHNITOIN_EXECUTION_LIST_DELETE;
  isUpdate = ApplicationPermission.TECHNITOIN_EXECUTION_LIST_UPDATE;
  plantSession: any;
  groupSession: any;
  userSession: any;
  spareParts: any = [
    { ID: 1, Name: 'Yes' },
    { ID: 0, Name: 'No' },
  ];
  user: any;
  groupCode: any;
  userCode: any;
  technicianExecutionWOID: number;
  technicianTaskId: number = 0;
  userId: any;
  vendors: any[] = [];
  woObject: any;
  private woSubscription!: Subscription;
  taskStatus: string = '';
  @ViewChild('vendorElement') vendorElement: any;
  constructor(
    public translater: TranslaterService,
    private baseApi: BaseApi,
    public translate: TranslateService,
    private toaster: ToastrService,
    private fb: FormBuilder,
    private router: Router,
    public datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    public toastr: ToastrService,
    private prevTaskService: prevTaskService,
    private technicianService: TechnicianService,
    public operatorExecutionService: OperatorExecutionService,
    public managerExecutionService: ManagerExecutionService,
    public prevConfigurationService: PrevConfigurationService,
    private techScoreService: TechScoreService,
    private userConfigService: UserConfigurationsService,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      this.getLangWords();
    });

    this.technicianForm = this.fb.group({
      line_area: ['', Validators.required],
      wo_id: ['', Validators.required],
      wo_status: ['', Validators.required],
      wo_type: ['', Validators.required],
      faliure_mode: ['', Validators.required],
      priority: ['', Validators.required],
      start_time: ['', Validators.required],
      complete_time: [''],
      spare_parts: ['', Validators.required],
      machineBreakdown: ['', Validators.required],
      spare_part_code: ['', Validators.required],
      sp_req_time: [''],
      sp_rec_time: [''],
      remarks: [''],
      before_pic: [''],
      after_pic: [''],
      remarks_manual: ['', Validators.required],
      visorremarks: [''],
      wo_creation_time: [''],
      technician_assigned_time: [''],
      wo_closed_time: [''],
      scrap: [''],
    });
    this.subTaskForm = this.fb.group({
      Id: [],
      woDetails: ['', Validators.required],
      responsible: ['', Validators.required],
      externalVendor: [''],
      newVendorName: [''],
      targetDate: ['', Validators.required],
      subTaskIsMachineBreakdown: [''],
      subTaskIsSpareParts: [''],
      subTaskSparePartCode: [''],
      subTaskSPRequestTime: [''],
      subTaskSPReceivedTime: [''],
      remarks: [''],
    });
    this.technicianForm.controls['line_area'].disable();
    this.technicianForm.controls['wo_id'].disable();
    this.technicianForm.controls['wo_status'].disable();
    this.technicianForm.controls['priority'].disable();
    this.technicianForm.controls['spare_part_code'].disable();
    this.technicianForm.controls['remarks'].disable();
    this.technicianForm.controls['visorremarks'].disable();
    this.frameworkComponents = {
      ActionEditDeleteBtnRendererTechnicianSubTask:
        ActionEditDeleteBtnRendererTechnicianSubTask,
      ExternalVendorRendererComponent: ExternalVendorRendererComponent,
      TechnicianRendererComponent: TechnicianRendererComponent,
    };
  }

  ngOnInit(): void {
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.userSession = this.baseApi.getUserSession();

    this.getLangWords();
    this.blobStorageUrl = Constants.BLOB_STORAGE_URL;
    this.userList = this.managerExecutionService.getUserData();
    this.getTechnicianValues();
    // Set edit mode based on technician data (after getTechnicianValues loads the data)
    setTimeout(() => {
      if (this.technician.ID && this.technician.ID > 0) {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
    }, 100);
    if (this.technician.SpareParts) {
      this.technicianForm.controls['spare_part_code'].enable();
      this.technicianForm.controls['spare_part_code'].setValidators([
        Validators.required,
      ]);
      this.technicianForm.controls['spare_part_code'].updateValueAndValidity();
      this.technicianForm.controls['sp_req_time'].enable();
      this.technicianForm.controls['sp_req_time'].updateValueAndValidity();
    } else {
      this.technicianForm.controls['spare_part_code'].disable();
      this.technicianForm.controls['spare_part_code'].setValidators(null);
      this.technicianForm.controls['spare_part_code'].updateValueAndValidity();
      this.technician.SparePartCode = '';
      this.technicianForm.controls['sp_req_time'].disable();
      this.technicianForm.controls['sp_req_time'].updateValueAndValidity();
      this.technician.SPRequestTime = '';
      this.technicianForm.controls['sp_rec_time'].disable();
      this.technicianForm.controls['sp_rec_time'].setValidators(null);
      this.technicianForm.controls['sp_rec_time'].updateValueAndValidity();
      this.technician.SPReceivedTime = '';
    }
    this.technicianForm.get('complete_time')?.valueChanges.subscribe(() => {
      const completeTimeValue = this.technicianForm.get('complete_time')?.value;
      if (completeTimeValue) {
        this.technicianForm
          .get('remarks_manual')
          ?.setValidators([Validators.required]);
      } else {
        this.technicianForm.get('remarks_manual')?.clearValidators();
      }
      this.technicianForm.get('remarks_manual')?.updateValueAndValidity();
    });
    this.getSessionData();
    this.getTechnicians();
    this.getVendors();
    this.woSubscription = this.technicianService
      .getWObject()
      .subscribe((wo: any) => {
        if (wo) {
          // console.log('Woo object: ', wo);
          this.woObject = wo;
          this.isEdit = true;
          // this.populateForm(wo);
        }
      });
    this.technicianExecutionWOID = this.technician.ID;
    this.getExternalWorkData();
  }

  disablePastDates = (date: Date | null): boolean => {
    if (!date) return false;

    // Get the selected target date from the form
    const selectedDate = this.subTaskForm?.get('targetDate')?.value;

    let comparisonDate: Date;

    if (selectedDate) {
      // If a date is already selected, use it as the minimum date
      comparisonDate = new Date(selectedDate);
    } else {
      // If no date is selected, use today as the minimum date
      comparisonDate = new Date();
    }

    comparisonDate.setHours(0, 0, 0, 0); // Normalize the date

    const currentDate = new Date(date);
    currentDate.setHours(0, 0, 0, 0); // Normalize the date being checked

    return currentDate >= comparisonDate; // Only allow dates >= comparison date
  };

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find((x) => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      this.getExternalWorkColumns();
      if (this.langObj) {
      }
    });
  }

  isSubmitting: boolean = false;
  submitForm(): void {
    if (this.subTaskForm.invalid) {
      console.warn('Form is invalid');
      return;
    }
    this.spinner.show();
    this.isSubmitting = true;

    const formValue = this.subTaskForm.value;

    const isNewVendor = this.vendorMode === 'new';
    const isExistingVendor = this.vendorMode === 'existing';

    const externalVendor =
      isNewVendor && formValue.newVendorName?.trim()
        ? formValue.newVendorName.trim()
        : null;

    const externalVendorId =
      isExistingVendor && formValue.externalVendor
        ? this.vendors.find((v) => v.Id === formValue.externalVendor)?.Id
        : null;

    // Format targetDate to ISO string
    const targetDate = formValue.targetDate
      ? new Date(formValue.targetDate).toISOString()
      : null;

    const payload = {
      Id: formValue.Id,
      TechnicianExecutionWOID: this.technician.ID,
      WOId: this.woObject.operExecWo.WOId,
      Detail: formValue.woDetails,
      ResponsibleID: formValue.responsible,
      ExternalVendor: externalVendor, // string if new vendor
      ExternalVendorId: externalVendorId, // ID if existing vendor
      TargetDate: targetDate,
      CompletionDate: null,
      Status: 'Pending',
      RMPM: 'RM',
      PlantCode: this.plantCode,
      GroupCode: this.groupCode,
      UserCode: this.userCode,
      IsManager: false,
      Remarks: formValue.remarks || null,
    };

    console.log('Submitting payload:', payload);
    const request$ = this.prevTaskService.addSubTaskWorkOrder(payload);
    request$.subscribe({
      next: (response: string) => {
        this.spinner.hide();
        console.log('Subtask created successfully:', response);
        this.toaster.success('SubTask Work Order Saved Successfully');
        this.isSubTaskSaved = true;
        this.resetForm();
        this.dialog.closeAll();
        this.technicianExecutionWOID = payload.TechnicianExecutionWOID;
        console.log('TaskId', this.technicianExecutionWOID);
        this.getExternalWorkData();
        this.isSubmitting = false;
        this.cdr.detectChanges();
        externalVendorId === null ? this.getVendors() : null;
      },
      error: (err) => {
        console.error('Error creating subtask:', err);
        this.spinner.hide();
        this.isSubmitting = false;
        this.cdr.detectChanges();
      },
    });
  }

  updateSubtaskForm(): void {
    if (this.subTaskForm.invalid) {
      console.warn('Form is invalid');
      // this.snackBar.open('Please fill all required fields', 'Close', { duration: 3000 });
      return;
    }
    this.spinner.show();
    this.isSubmitting = true;

    const formValue = this.subTaskForm.value;

    const isNewVendor = this.vendorMode === 'new';
    const isExistingVendor = this.vendorMode === 'existing';

    const externalVendor =
      isNewVendor && formValue.newVendorName?.trim()
        ? formValue.newVendorName.trim()
        : null;

    const externalVendorId =
      isExistingVendor && formValue.externalVendor
        ? this.vendors.find((v) => v.Id === formValue.externalVendor)?.Id
        : null;

    // Format targetDate to ISO string
    const targetDate = formValue.targetDate
      ? new Date(formValue.targetDate).toISOString()
      : null;

    const payload = {
      Id: formValue.Id,
      TechnicianExecutionWOID: this.technician.ID,
      WOId: this.woObject.operExecWo.WOId,
      Detail: formValue.woDetails,
      ResponsibleID: formValue.responsible,
      ExternalVendor: externalVendor, // string if new vendor
      ExternalVendorId: externalVendorId, // ID if existing vendor
      TargetDate: targetDate,
      CompletionDate: null,
      Status: 'Pending',
      RMPM: 'RM',
      PlantCode: this.plantCode,
      GroupCode: this.groupCode,
      UserCode: this.userCode,
      IsManager: false,
      SubTaskIsMachineBreakdown: formValue.subTaskIsMachineBreakdown === 1 ? true : formValue.subTaskIsMachineBreakdown === 0 ? false : null,
      SubTaskIsSpareParts: formValue.subTaskIsSpareParts === 1 ? true : formValue.subTaskIsSpareParts === 0 ? false : null,
      SubTaskSparePartCode: formValue.subTaskSparePartCode || null,
      SubTaskSPRequestTime: formValue.subTaskSPRequestTime ? new Date(formValue.subTaskSPRequestTime).toISOString() : null,
      SubTaskSPReceivedTime: formValue.subTaskSPReceivedTime ? new Date(formValue.subTaskSPReceivedTime).toISOString() : null,
      Remarks: formValue.remarks || null,
    };

    console.log('Submitting payload:', payload);
    const request$ = this.prevTaskService.updateSubTaskWorkOrder(payload);
    request$.subscribe({
      next: (response: string) => {
        this.spinner.hide();
        console.log('Subtask Updated successfully:', response);
        if (payload.Id) {
          this.toaster.success('SubTask  Work Order Updated Successfully');
        }
        this.isSubTaskSaved = true;
        this.resetForm();
        this.dialog.closeAll();
        this.technicianExecutionWOID = payload.TechnicianExecutionWOID;
        console.log('TaskId', this.technicianExecutionWOID);
        this.getExternalWorkData();
        this.isSubmitting = false;
        this.cdr.detectChanges();
        externalVendorId === null ? this.getVendors() : null;
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Error creating subtask:', err);
        // this.snackBar.open('Failed to create subtask: ' + (err.message || 'Unknown error'), 'Close', { duration: 5000 });
        this.isSubmitting = false;
        this.cdr.detectChanges();
      },
    });
  }

  getExternalWorkData(): void {
    if (!this.technician.ID && !this.technician.operExecWO) {
      // console.warn('technicianTaskId is not available');
      this.rowData = [];
      return;
    }
    this.prevTaskService
      .getSubTaskWorkOrderByTaskId(
        this.technicianTaskId,
        this.technician.ID,
        this.woObject.operExecWo.WOId
      )
      .subscribe({
        next: (res: any[]) => {
          console.log('res', res);
          this.rowData = res.map((item) => ({
            id: item.Id,
            woDetails: item.Detail,
            responsible:
              this.getResponsibleName(item.ResponsibleID) ||
              item.ResponsibleName ||
              item.ResponsibleID,
            responsibleId: item.ResponsibleID,
            externalVendor: item.externalVendor || null,
            IsManager: item.IsManager || false,
            CreatedBy: this.getResponsibleName(item.CreatedBy) || item.CreatedBy,
            UpdatedBy: this.getResponsibleName(item.UpdatedBy) || item.UpdatedBy,
            Updator: item.Updator || '',
            externalVendorId: item.ExternalVendorId,
            status: item.Status,
            targetDate: item.TargetDate
              ? item.TargetDate
              : '',
            completionDate: item.CompletionDate
              ? item.CompletionDate
              : '',
            subTaskIsMachineBreakdown: item.SubTaskIsMachineBreakdown,
            subTaskIsSpareParts: item.SubTaskIsSpareParts,
            subTaskSparePartCode: item.SubTaskSparePartCode || '',
            subTaskStartTime: item.SubTaskStartTime || null,
            subTaskSPRequestTime: item.SubTaskSPRequestTime || null,
            subTaskSPReceivedTime: item.SubTaskSPReceivedTime || null,
            subTaskRemarks: item.SubTaskRemarks || null,
            isApproved: item.IsApproved,
            approvedBy: item.ApprovedBy,
            approvalDate: item.ApprovalDate,
          }));
          this.isPending = this.rowData.some(
            (item) => item.status === 'Pending'
          );
          console.log('Subtasks loaded:', this.rowData);
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error('Error fetching subtasks:', err);
          this.rowData = [];
          // this.snackBar.open('Failed to load subtasks: ' + (err.message || 'Unknown error'), 'Close', { duration: 5000 });
          this.cdr.detectChanges();
        },
      });
  }
  deleteRow(element: any): void {
    console.log('Current subTasksArray:', this.rowData);
    console.log('Element to delete:', element.rowData);
    const data = {
      Id: element.rowData.id,
      UserCode: this.userCode,
    };
    console.log('datafordelete', data);
    this.prevTaskService.deletePrevTask(data).subscribe({
      next: (res: string) => {
        console.log('Server says:', res);
        this.toaster.success('SubTask Work Order deleted successfully.');
        this.getExternalWorkData();
      },
      error: (err) => {
        console.error('Delete failed:', err);
      },
    });
  }

  getResponsibleName(responsibleId: string): string {
    const technician = this.technicians.find(
      (tech) => tech.id === responsibleId
    );
    return technician ? technician.name : '';
  }

  // img popup
  imgview(e: any) {
    let dialogRef = this.dialog.open(this.technicianimageViewModal, {
      height: '90%',
      width: '90%',
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  oncloseimg() {
    this.dialog.closeAll();
  }

  imgview1(e1: any) {
    let dialogRef = this.dialog.open(this.operatorimageViewModal, {
      height: '90%',
      width: '90%',
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  oncloseimg1() {
    this.dialog.closeAll();
  }
  // img popup

  openFile() {
    this.fileInput.nativeElement.click();
  }

  readFile(event: any) {
    const files = event.target.files;
    if (files) {
      for (let file of files) {
        if (file.type.match('image.*')) {
          this.fileType = 'image';
          this.FileList.push(file);
        } else {
          this.toaster.warning('Warning', 'File Format Not Valid ');
          return;
        }
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.imageSrc = e.target.result;
          this.FileData.push({
            FileType: this.fileType,
            ImageSrc: this.imageSrc,
          });
        };
        reader.readAsDataURL(file);
      }
      event.target.value = '';
    }
  }
  getSessionData(): void {
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupCode = this.groupSession.groupCode;
    this.plantCode = this.plantSession.plantCode;
    this.user = this.baseApi.getUserSession();
    this.userId = this.user.userId;
    this.userCode = this.user.userCode;
    // this.userMenus = this.baseApi.getUserPermissionsSession();
    // this.pageId = this.baseApi.getCurrentMenuID();
    // this.loggedUser = this.baseApi.getUserSession();
  }

  onPanelClose(isOpen: boolean, type: string, inputElement: HTMLInputElement) {
    if (!isOpen) {
      // Reset the search input value
      inputElement.value = '';

      switch (type) {
        case 'tech':
          this.filteredTechnicianList = [...this.technicians];
          break;
        case 'vender':
          this.vendorsList = [...this.vendors];
          break;
      }
    }
  }
  searchValues(event: any, type: string) {
    const filter = event.target.value.toLowerCase();
    switch (type) {
      case 'tech':
        this.filteredTechnicianList = this.technicians.filter((tech) =>
          tech.name.toLowerCase().includes(filter)
        );
        break;
      case 'vender':
        this.vendorsList = this.vendors.filter((ven) =>
          ven.Name.toLowerCase().includes(filter)
        );
        break;
    }
  }
  getTechnicians(): void {
    if (!this.plantCode) {
      console.warn('Plant code is not available');
      this.technicians = [];
      return;
    }

    const key = {
      Plant: this.plantSession?.plantCode,
    };

    this.techScoreService.getAllTechScoreList(key).subscribe({
      next: (res: any[]) => {
        // Remove duplicates based on TechId or EmployeeCode
        const uniqueTechnicians = Array.from(
          new Map(
            res.map((item) => [
              item.TechId || item.EmployeeCode,
              {
                id: item.TechId || item.EmployeeCode,
                name: item.full_name,
              },
            ])
          ).values()
        );

        this.technicians = uniqueTechnicians;
        this.filteredTechnicianList = this.technicians; // Initialize filtered list with all technicians
        console.log('Technicians loaded:', this.technicians);
      },
      error: (err) => {
        console.error('Error fetching technicians:', err);
        this.technicians = [];
      },
    });
  }

  removeFile(i: any) {
    this.FileData.splice(i, 1);
    this.FileList.splice(i, 1);
  }

  deleteFile(i: any) {
    this.EditFileData.splice(i, 1);
    this.technician.AfterPicture.push(i);
  }

  changeTechnician() {
    if (this.userSession?.userCode == this.technician.TechnicianId) {
      this.technicianForm.controls['start_time'].setValidators([
        Validators.required,
      ]);
      this.technicianForm.controls['start_time'].updateValueAndValidity();
      this.technician.StartTime = new Date();
    } else {
      this.technicianForm.controls['start_time'].setValidators([
        Validators.nullValidator,
      ]);
      this.technicianForm.controls['start_time'].updateValueAndValidity();
      this.technician.StartTime = '';
    }
  }

  getTechnicianValues() {
    var data = this.technicianService.getTechnicianValues();
    if (data) {
      if (data.StartTime) {
        this.disableStartTime = true;
        this.technicianForm.start_time = new Date(data.StartTime ?? null);
      } else {
        this.disableStartTime = false;
        this.technicianForm.start_time = new Date(data.TaskExpireTime ?? null);
      }
      let OperatorUploadFiles: any = [];
      this.taskStatus = data.Status;
      this.isviewMode = data.isviewButton;
      this.technician.LineArea = data.operExecWo.line
        ? data.operExecWo.line.plDesc
        : '';
      this.technician.operExecWO = data.operExecWo.ID;
      this.technician.DisplayWOId = data.operExecWo.WOId;
      this.technician.ManagerStatus = data.operExecWo.ManagerStatus;
      this.technician.WOStatusDisplay =
        data.operExecWo.WOStatus == 1
          ? 'Open'
          : data.operExecWo.WOStatus == 2
            ? 'Close'
            : data.operExecWo.WOStatus == 3
              ? 'Complete'
              : data.operExecWo.WOStatus == 4
                ? 'Delay'
                : data.operExecWo.WOStatus == 6
                  ? 'ReOpen'
                  : 'In Progress';
      if (this.technician.ManagerStatus == 0) {
        this.technicianForm.controls['priority'].enable();
        this.technicianForm.controls['priority'].updateValueAndValidity();
        this.technicianForm.controls['spare_part_code'].enable();
        this.technicianForm.controls[
          'spare_part_code'
        ].updateValueAndValidity();
      }

      if (data.operExecWo.SpareParts) {
        this.technicianForm.controls['spare_part_code'].enable();
        this.technicianForm.controls['spare_part_code'].setValidators([
          Validators.required,
        ]);
        this.technicianForm.controls[
          'spare_part_code'
        ].updateValueAndValidity();
      } else {
        this.technicianForm.controls['spare_part_code'].disable();
        this.technicianForm.controls['spare_part_code'].setValidators(null);
        this.technicianForm.controls[
          'spare_part_code'
        ].updateValueAndValidity();
      }

      if (this.PriorityList && this.PriorityList.length) {
        let priObj = this.PriorityList.find(
          (pri: any) => pri.Name == data.Priority
        );
        this.technician.Priority = priObj && priObj.ID ? priObj.ID : '';
      }
      this.technician.WOType = data.operExecWo.WOType.ID;
      this.technician.FailureMode = data.operExecWo.FailureMode.ID;
      this.technician.SpareParts = data.operExecWo.SpareParts;
      this.technician.SparePartCode = data.SparePartCode;
      this.scode = data.SparePartCode;

      this.technician.Remark = data.operExecWo.Remark;
      this.technician.SupervisorRemark = data.ManagerRemarks;
      let WOID = data.operExecWo.ID;
      this.Group = data.operExecWo.Group.egId;
      this.Plant = data.operExecWo.Plant.ptId;

      if (data.operExecWo.UploadPicture) {
        OperatorUploadFiles = data.operExecWo.UploadPicture.split(',');
        for (let i = 0; i < OperatorUploadFiles.length; i++) {
          this.OperatorFiles.push({ ImageSrc: OperatorUploadFiles[i] });
        }
      }
      this.technician.OpCreatedAt = data.operExecWo.TimeStamp;
      this.technician.AssignTechnicianTimeStamp =
        data?.AssignTechnicianTimeStamp;
      this.technician.WOCreationTime =
        data.operExecWo && data.operExecWo.TimeStamp
          ? moment(data.operExecWo.TimeStamp).format('DD/MM/YYYY hh:mm a')
          : '';
      this.technician.WOClosedTime =
        data.operExecWo && data.operExecWo.ClosedAt
          ? moment(data.operExecWo.ClosedAt).format('DD/MM/YYYY hh:mm a')
          : '';
      this.technician.TechnicianAssignedTime = data.AssignTechnicianTimeStamp
        ? moment(data.AssignTechnicianTimeStamp).format('DD/MM/YYYY hh:mm a')
        : '';
      this.technician.MachineBreakdown = data.operExecWo.MachineBreakdown
        ? 1
        : 0;
      const technicianAssignedTime = new Date(data.AssignTechnicianTimeStamp);
      if (technicianAssignedTime < new Date())
        this.technician.StartTime = new Date();
      else this.technician.StartTime = null;
      this.getTechnician(WOID);
      this.getWOTypeFailureData();
    } else this.router.navigateByUrl('/PM/TechnicianExecutionWindow');
  }

  findManagerData() {
    this.spinnerText = 'Fetching Manager Data';
    this.spinner.show();
    const obj = {
      UserId: '',
      WOId: this.technician.operExecWO,
    };
    this.managerExecutionService.getOperatorData(obj).subscribe(
      (res: any) => {
        if (res && res.technician && res.technician.length) {
          for (const tech of res.technician) {
            let techObj = this.userList.find((user: any) => {
              return user.UserId == tech.UserId;
            });
            if (techObj) this.technicianList.push(techObj);
          }
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.message);
      }
    );
  }

  getWOTypeFailureData() {
    this.spinnerText = 'Fetching Master Data';
    this.spinner.show();
    const data = {
      WOType: this.technician.WOType,
      group: this.groupSession?.groupCode,
      plant: this.plantSession?.plantCode,
    };
    this.operatorExecutionService.getOperatorMasterData(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.woType = res.WOTypes;
          this.failMode = res.failureModes;
          this.technician.WOType = this.technician.WOType;
          this.technician.FailureMode = this.technician.FailureMode;
        } else this.toaster.error('Error', res.message);
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error('Error', err.message);
      }
    );
  }

  getTechnician(WOId: any) {
    this.spinner.show();
    this.spinnerText = 'Fetching Technician Data';
    this.technicianService.getTechnician(WOId).subscribe(
      (res: any) => {
        let data = res.WO;
        this.PriorityList = res.priority;
        if (data.operExecWo.techExc == null) {
          this.isEdit = false;
          this.technician.Priority =
            data.Priority && data.Priority.ID ? data.Priority.ID : '';
        } else {
          this.isEdit = true;
          this.technicianForm.controls['wo_type'].disable();
          this.technicianForm.controls['faliure_mode'].disable();
          let UploadFiles = [];
          this.technician.LineArea = data.operExecWo.line
            ? data.operExecWo.line.plDesc
            : '';
          this.technician.operExecWO = data.operExecWo.ID;
          this.technician.DisplayWOId = data.operExecWo.WOId;
          this.technician.WOStatus = data.operExecWo.WOStatus;
          this.technician.WOStatusDisplay =
            data.operExecWo.WOStatus == 1
              ? 'Open'
              : data.operExecWo.WOStatus == 2
                ? 'Close'
                : data.operExecWo.WOStatus == 3
                  ? 'Complete'
                  : data.operExecWo.WOStatus == 4
                    ? 'Delay'
                    : data.operExecWo.WOStatus == 6
                      ? 'ReOpen'
                      : 'In Progress';
          this.technician.WOType = data.operExecWo.WOType.ID;
          this.technician.FailureMode = data.operExecWo.FailureMode.ID;
          this.technician.Priority =
            data.Priority && data.Priority.ID ? data.Priority.ID : '';
          this.technician.SpareParts = data.operExecWo.SpareParts;
          this.technician.SparePartCode = data.SparePartCode;
          this.scode = data.SparePartCode;
          this.technician.Remark = data.operExecWo.Remark;
          this.technician.UploadPicture = data.operExecWo.UploadPicture;
          this.technician.StartTime = data.operExecWo.techExc.StartTime;
          this.technician.CompleteTime = data.operExecWo.techExc.CompleteTime;
          this.technician.SPRequestTime = data.operExecWo.techExc.SPRequestTime;
          this.spReqTime = data.operExecWo.techExc.SPRequestTime;
          this.technician.SPReceivedTime =
            data.operExecWo.techExc.SPReceivedTime;
          this.spRecTime = data.operExecWo.techExc.SPReceivedTime;
          this.technician.Scrap = data.operExecWo.techExc.Scrap;
          this.technician.Remarks = data.operExecWo.techExc.Remarks;
          this.technician.ID = data.operExecWo.techExc.ID;
          this.technician.SupervisorRemark = data.ManagerRemarks;
          if (data.operExecWo.techExc.AfterPicture) {
            UploadFiles = data.operExecWo.techExc.AfterPicture.split(',');
            for (let i = 0; i < UploadFiles.length; i++) {
              this.EditFileData.push({ ImageSrc: UploadFiles[i] });
            }
          }
          this.technician.WOCreationTime =
            data.operExecWo && data.operExecWo.TimeStamp
              ? moment(data.operExecWo.TimeStamp).format('DD/MM/YYYY hh:mm a')
              : '';
          this.technician.WOClosedTime =
            data.operExecWo && data.operExecWo.ClosedAt
              ? moment(data.operExecWo.ClosedAt).format('DD/MM/YYYY hh:mm a')
              : '';
        }
        if (this.technician.ID && this.technician.ID > 0) {
          this.isEdit = true;
        } else {
          this.isEdit = false;
        }
        this.getExternalWorkData();
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error(error.error.message);
        this.spinner.hide();
      }
    );
  }

  setValidateSparePartsCode() {
    if (this.technician.SpareParts) {
      this.technicianForm.controls['spare_part_code'].enable();
      this.technicianForm.controls['spare_part_code'].setValidators([
        Validators.required,
      ]);
      this.technicianForm.controls.spare_part_code.setValue(this.scode);
      this.technicianForm.controls['sp_req_time'].enable();
      this.technicianForm.controls.sp_req_time.setValue(this.spReqTime);
      this.technicianForm.controls['sp_rec_time'].enable();
      this.technicianForm.controls.sp_rec_time.setValue(this.spRecTime);
    } else {
      this.technicianForm.controls['spare_part_code'].disable();
      this.technicianForm.controls['spare_part_code'].setValidators(null);
      this.technicianForm.controls['spare_part_code'].updateValueAndValidity();
      this.technician.SparePartCode = '';
      this.technicianForm.controls['sp_req_time'].disable();
      this.technicianForm.controls['sp_req_time'].updateValueAndValidity();
      this.technician.SPRequestTime = '';
      this.technicianForm.controls['sp_rec_time'].disable();
      this.technicianForm.controls['sp_rec_time'].setValidators(null);
      this.technicianForm.controls['sp_rec_time'].updateValueAndValidity();
      this.technician.SPReceivedTime = '';
    }
  }

  setValidateSubTaskSparePartsCode() {
    this.isSparePartsYes = this.subTaskForm.get('subTaskIsSpareParts')?.value === 1;

    if (this.isSparePartsYes) {
      this.subTaskForm.controls['subTaskSparePartCode'].setValidators([Validators.required]);
      this.subTaskForm.controls['subTaskSPRequestTime'].setValidators([Validators.required]);
    } else {
      this.subTaskForm.controls['subTaskSparePartCode'].clearValidators();
      this.subTaskForm.controls['subTaskSparePartCode'].setValue('');
      this.subTaskForm.controls['subTaskSPRequestTime'].clearValidators();
      this.subTaskForm.controls['subTaskSPRequestTime'].setValue('');
    }

    this.subTaskForm.controls['subTaskSparePartCode'].updateValueAndValidity();
    this.subTaskForm.controls['subTaskSPRequestTime'].updateValueAndValidity();
  }

  dateChanged(val) {
    if (val == 'starttime') {
      if (
        new Date(this.technician.StartTime) <
        new Date(this.technician.OpCreatedAt)
      ) {
        this.toastr.warning(
          'Technician Start Time Should Not Be Prior To Work Order Created Time',
          'Warning',
          {
            timeOut: 3000,
          }
        );
        this.technician.StartTime = '';
        this.technicianForm.patchValue({ start_time: null });
        return;
      } else if (
        this.technician.AssignTechnicianTimeStamp &&
        new Date(this.technician.StartTime) <
        new Date(this.technician.AssignTechnicianTimeStamp)
      ) {
        // start Time should be less than assigned technician time
        this.toastr.warning(
          'Technician Start Time Should Not Be Prior To Assigned Technician Time',
          'Warning',
          {
            timeOut: 3000,
          }
        );
        this.technician.StartTime = '';
        this.technicianForm.patchValue({ start_time: null });
        return;
      } else if (this.technician.CompleteTime) {
        if (
          new Date(this.technician.StartTime) >
          new Date(this.technician.CompleteTime)
        ) {
          this.toastr.warning(
            'Technician Start Time Should Not Be Greater Than CompleteTime',
            'Warning',
            {
              timeOut: 3000,
            }
          );
          this.technician.StartTime = '';
          this.technicianForm.patchValue({ start_time: null });
          return;
        }
      }
    }
    if (val == 'spReceived')
      if (
        new Date(this.technician.SPReceivedTime) <
        new Date(this.technician.SPRequestTime)
      ) {
        this.toastr.warning(
          'Technician SP Received Time Should Not Be Prior To Technician SP Request Time',
          'Warning',
          {
            timeOut: 3000,
          }
        );
        this.technician.SPReceivedTime = '';
        this.technicianForm.patchValue({ sp_rec_time: null });
        return;
      }
    if (val == 'spRequest')
      if (
        new Date(this.technician.SPRequestTime) <
        new Date(this.technician.StartTime)
      ) {
        this.toastr.warning(
          'Technician SP Request Time Should Not Be Prior To Technician Start Time',
          'Warning',
          {
            timeOut: 3000,
          }
        );
        this.technician.SPRequestTime = '';
        this.technicianForm.patchValue({ sp_req_time: null });
        return;
      }
    if (this.technician.CompleteTime) {
      if (val == 'completetime') {
        let comTime = new Date(this.technician.CompleteTime);
        let curTime = new Date();
        if (comTime > curTime) {
          this.toastr.warning(
            'Complete Time Field Is Not Accept Future Time',
            'Warning',
            {
              timeOut: 3000,
            }
          );
          this.technician.CompleteTime = '';
          this.technicianForm.patchValue({ complete_time: null });
          return;
        } else if (
          new Date(this.technician.CompleteTime) <
          new Date(this.technician.SPReceivedTime)
        ) {
          this.toastr.warning(
            'Technician Complete Time Should Not Be Prior To Technician SP Received Time',
            'Warning',
            {
              timeOut: 3000,
            }
          );
          this.technician.CompleteTime = '';
          this.technicianForm.patchValue({ complete_time: null });
          return;
        } else if (
          new Date(this.technician.CompleteTime) <
          new Date(this.technician.SPRequestTime)
        ) {
          this.toastr.warning(
            'Technician Complete Time Should Not Be Prior To Technician SP Request Time',
            'Warning',
            {
              timeOut: 3000,
            }
          );
          this.technician.CompleteTime = '';
          this.technicianForm.patchValue({ complete_time: null });
          return;
        } else if (
          new Date(this.technician.CompleteTime) <
          new Date(this.technician.StartTime)
        ) {
          this.toastr.warning(
            'Technician Complete Time Should Not Be Prior To Technician Start Time',
            'Warning',
            {
              timeOut: 3000,
            }
          );
          this.technician.CompleteTime = '';
          this.technicianForm.patchValue({ complete_time: null });
          return;
        }
      }
    }
  }

  onSubmit() {
    if (
      new Date(this.technician.StartTime) <
      new Date(this.technician.OpCreatedAt)
    ) {
      this.toastr.warning(
        'Technician Start Time Should Not Be Prior To Work Order Created Time',
        'Warning',
        {
          timeOut: 3000,
        }
      );
      return;
    }
    if (this.technician.SPReceivedTime) {
      if (!this.technician.SPRequestTime) {
        this.toastr.warning('Please Fill SP Request Time Field', 'Error', {
          timeOut: 3000,
        });
        return;
      } else {
        if (!this.technician.StartTime) {
          this.toastr.warning('Please Fill Start Time Field', 'Error', {
            timeOut: 3000,
          });
          return;
        }
      }
    } else {
      if (this.technician.SPRequestTime) {
        if (!this.technician.StartTime) {
          this.toastr.warning('Please Fill Start Time Field', 'Error', {
            timeOut: 3000,
          });
          return;
        }
      }
    }

    if (this.technician.CompleteTime) {
      let comTime = new Date(this.technician.CompleteTime);
      let curTime = new Date();
      if (comTime > curTime) {
        this.toastr.warning(
          'Complete Time Field Is Not Accept Future Time',
          'Warning',
          {
            timeOut: 3000,
          }
        );
        return;
      } else if (
        new Date(this.technician.CompleteTime) <
        new Date(this.technician.SPReceivedTime)
      ) {
        this.toastr.warning(
          'Technician Complete Time Should Not Be Prior To Technician SP Received Time',
          'Warning',
          {
            timeOut: 3000,
          }
        );
        return;
      } else if (
        new Date(this.technician.CompleteTime) <
        new Date(this.technician.SPRequestTime)
      ) {
        this.toastr.warning(
          'Technician Complete Time Should Not Be Prior To Technician SP Request Time',
          'Warning',
          {
            timeOut: 3000,
          }
        );
        return;
      } else if (
        new Date(this.technician.CompleteTime) <
        new Date(this.technician.StartTime)
      ) {
        this.toastr.warning(
          'Technician Complete Time Should Not Be Prior To Technician Start Time',
          'Warning',
          {
            timeOut: 3000,
          }
        );
        return;
      }
    }

    if (this.technician.SPReceivedTime) {
      if (
        new Date(this.technician.SPReceivedTime) <
        new Date(this.technician.SPRequestTime)
      ) {
        this.toastr.warning(
          'Technician SP Received Time Should Not Be Prior To Technician SP Request Time',
          'Warning',
          {
            timeOut: 3000,
          }
        );
        return;
      } else if (
        new Date(this.technician.SPReceivedTime) <
        new Date(this.technician.StartTime)
      ) {
        this.toastr.warning(
          'Technician SP Received Time Should Not Be Prior To Technician Start Time',
          'Warning',
          {
            timeOut: 3000,
          }
        );
        return;
      }
    }

    if (this.technician.SPRequestTime) {
      if (
        new Date(this.technician.SPRequestTime) <
        new Date(this.technician.StartTime)
      ) {
        this.toastr.warning(
          'Technician SP Request Time Should Not Be Prior To Technician Start Time',
          'Warning',
          {
            timeOut: 3000,
          }
        );
        return;
      }
    }

    if (this.technician.SpareParts) {
      this.technicianForm.controls['sp_req_time'].updateValueAndValidity();
    } else {
      this.technicianForm.controls['sp_req_time'].setValidators(null);
      this.technicianForm.controls['sp_req_time'].updateValueAndValidity();
    }

    if (this.technicianForm.invalid) {
      this.toastr.warning('Please Fill All Required Field', 'Error', {
        timeOut: 3000,
      });
      return;
    } else {
      this.technician.StartTime = this.technician.StartTime;
      this.technician.CompleteTime = this.technician.CompleteTime;
      this.technician.SPRequestTime = this.technician.SPRequestTime;
      this.technician.SPReceivedTime = this.technician.SPReceivedTime;
      this.technician.CreatedAt = new Date();
      this.technician.CreatedBy = this.userSession?.userCode;
      this.technician.TechnicianId = this.userSession?.userCode;
      this.spinner.show();

      var mgrData = {
        Priority: this.technician.Priority,
        SpareParts: this.technician.SpareParts,
        SparePartCode: this.technician.SparePartCode,
        WOId: this.technician.operExecWO,
        AssignTechnicianTimeStamp: new Date(),
        CreatedBy: this.userSession?.userCode,
        assignUser: this.userSession?.userCode,
        status: this.technician.ManagerStatus,
        MachineBreakdown: this.technician.MachineBreakdown,
        Scrap: this.technician.Scrap,
      };
      if (this.isEdit == false) {
        this.spinnerText = 'Creating Technician Data';
        const Formvalues = new FormData();
        for (const file of this.FileList)
          Formvalues.append('Image', file, file.name);
        Formvalues.append('Data', JSON.stringify(this.technician));
        Formvalues.append('MgrData', JSON.stringify(mgrData));
        this.technicianService.addTechnician(Formvalues).subscribe(
          (res: any) => {
            this.spinner.hide();
            if (res.techID) {
              this.technician.ID = res.techID;
            }
            if (res.status) {
              if (res.result) {
                this.addUserWiseNotification(res.result);
              }
              // this.toastr.success(
              //   res.message || `Data Inserted Successfully`,
              //   'Success',
              //   {
              //     timeOut: 3000,
              //   }
              // );
              this.isEdit = true;
              // this.router.navigateByUrl('/PM/TechnicianExecutionWindow');
            }
            this.FileList = [];
          },
          (err: any) => {
            this.spinner.hide();
            this.toastr.error(err.message || `Server Error`, 'Error', {
              timeOut: 3000,
            });
          }
        );
      } else {
        this.spinnerText = 'Updating Technician Data';
        var data = {
          StartTime: this.technician.StartTime,
          CompleteTime: this.technician.CompleteTime,
          SPRequestTime: this.technician.SPRequestTime,
          SPReceivedTime: this.technician.SPReceivedTime,
          AfterPicture: this.technician.AfterPicture,
          Remarks: this.technician.Remarks,
          TechnicianId: this.userSession?.userCode,
          ID: this.technician.ID,
          WOType: this.technician.WOType,
          FailureMode: this.technician.FailureMode,
          Scrap: this.technician.Scrap,
        };
        const Formvalues = new FormData();
        for (const file of this.FileList)
          Formvalues.append('Image', file, file.name);
        Formvalues.append('Data', JSON.stringify(data));
        Formvalues.append('MgrData', JSON.stringify(mgrData));
        this.technicianService.updateTechnician(Formvalues).subscribe(
          (res: any) => {
            this.technician.AfterPicture = [];
            this.spinner.hide();
            if (res.status) {
              if (res.result) {
                this.addUserWiseNotification(res.result);
              }
              this.toastr.success(
                res.message || `Data Updated Successfully`,
                'Success',
                {
                  timeOut: 3000,
                }
              );
              // Remove navigation to stay on same page after successful update
              // this.router.navigateByUrl('/PM/TechnicianExecutionWindow');
            }
            this.FileList = [];
          },
          (err: any) => {
            this.spinner.hide();
            this.toastr.error(err.message || `Server Error`, 'Error', {
              timeOut: 3000,
            });
          }
        );
      }
    }
  }

  addUserWiseNotification(val: any) {
    const data = {
      userId: val.RequestedBy, // multiple user ids send [104,105,7,9]
      desc: `Work Order ID ${val.WOId} Is Completed`,
      title: 'Work Order',
      createdBy: JSON.parse(localStorage.user).UserId,
    };
    this.spinnerText = 'Adding User Wise Notification';
    this.spinner.show();
    this.prevConfigurationService.addUserWiseNotification(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.toaster.success('Success', res.message);
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  resetForm(): void {
    this.subTaskForm.reset();
    this.vendorToggle = false;
    this.vendorMode = 'existing';
    this.subTaskForm.patchValue({
      woDetails: '',
      responsible: '',
      externalVendor: '',
      newVendorName: '',
      targetDate: '',
      remarks: '',
      subTaskIsSpareParts: 0,
      subTaskSparePartCode: '',
      subTaskSPRequestTime: '',
    });
    this.subTaskForm.markAsPristine();
    this.subTaskForm.markAsUntouched();
    console.log('Form reset');
  }

  openWOdialog(): void {
    this.subtaskFormMode = true;
    this.isSubTaskSaved = false;
    this.isViewMode = false;
    this.resetForm();
    this.isSparePartsYes = false;
    // Clear validators for spare parts fields on initial form open
    this.setValidateSubTaskSparePartsCode();
    const dialogRef = this.dialog.open(this.subTaskDialog, {
      height: 'auto',
      width: '90%',
    });

    dialogRef.afterClosed().subscribe(() => {
      if (!this.isSubTaskSaved) {
        this.resetForm();
      }
      this.updateGridData();
      this.cdr.detectChanges();
    });
  }
  ensureGridReady() {
    if (!this.agGrid || !this.agGrid.api) {
      return;
    }
    this.gridApi = this.agGrid.api;
    this.gridColumnApi = this.agGrid.columnApi;
    this.gridApi.setRowData(this.rowData);
    this.gridApi.refreshCells({ force: true });
    this.gridApi.sizeColumnsToFit();
  }

  onTabChange(event: MatTabChangeEvent) {
    if (event.index === 1) {
      this.ensureGridReady();
      this.updateGridData();
    }
    this.resetUnsavedSubTaskForm();
  }
  updateGridData() {
    if (this.gridApi) {
      this.gridApi.setRowData(this.rowData);
      this.gridApi.refreshCells({ force: true });
    }
  }
  resetUnsavedSubTaskForm(): void {
    if (!this.isSubTaskSaved && this.subTaskForm.dirty) {
      this.resetForm();
      this.dialog.closeAll();
    }
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setRowData(this.rowData);
    this.gridApi.sizeColumnsToFit();
  }
  cellClicked(params: any): void {
    const col = params.colDef.field;
  }
  getVendors() {
    const data = {
      PlantCode: this.plantCode,
      GroupCode: this.groupCode,
    };
    this.prevTaskService.getPMExternalVendor(data).subscribe((res: any) => {
      this.vendors = res.data;
      this.vendorsList = this.vendors;
      this.cdr.detectChanges();
    });
  }
  onVendorToggleChange(event: any) {
    if (event.checked) {
      this.vendorMode = 'new';
      this.vendorElement.nativeElement.focus();
    } else {
      this.vendorMode = 'existing';
    }
  }

  getExternalWorkColumns() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: 'ActionEditDeleteBtnRendererTechnicianSubTask',
        headerValueGetter: this.localizeHeader.bind(this),
        cellRendererParams: {
          onClickEdit: this.editRow.bind(this),
          onClickDelete: this.deleteRow.bind(this),
          onClickView: this.viewRow.bind(this),
          isUpdate: this.isUpdate, // <--- pass it
          isDelete: this.isDelete, // <--- pass it
          isTechnicianScreen: true, // <--- pass it
        },
        pinned: 'left',
        minWidth: 200,
      },
      {
        headerName: 'WO Details',
        field: 'woDetails',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Responsible',
        field: 'responsible',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'External Vendor',
        field: 'externalVendor',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Remarks',
        field: 'subTaskRemarks',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Status',
        field: 'status',
        minWidth: 200,
        cellStyle: (params) => {
          if (params.value === 'Pending') {
            return {
              backgroundColor: '#FFFF00',
              color: 'black',
              fontWeight: 'bold',
            };
          }
          else if (params.value === 'InProcess') {
            return {
              backgroundColor: '#FFA500',
              color: 'white',
              fontWeight: 'bold',
            };
          }
          else if (params.value === 'Completed' || params.value === 'Closed') {
            return {
              backgroundColor: '#38CF36',
              color: 'white',
              fontWeight: 'bold',
            };
          }
          return null;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Target Date',
        field: 'targetDate',
        minWidth: 200,
        valueFormatter: (params: any) =>
          params.value ? this.formatCellData(params.value, 'dateOnly') : null,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Completion Date',
        field: 'completionDate',
        minWidth: 200,
        valueFormatter: (params: any) =>
          params.value ? this.formatCellData(params.value, 'dateTime') : null,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'CreatedBy',
        field: 'CreatedBy',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Created By',
        field: 'IsManager',
        minWidth: 200,
        valueFormatter: (params: any) => {
          const isManager = params.value === true || params.value === 'true';
          return isManager ? 'Manager' : 'Technician';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'UpdatedBy',
        field: 'UpdatedBy',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Updator',
        field: 'Updator',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Machine Breakdown',
        field: 'subTaskIsMachineBreakdown',
        minWidth: 200,
        valueFormatter: (params: any) => {
          if (params.value === true || params.value === 1) return 'Yes';
          if (params.value === false || params.value === 0) return 'No';
          return '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Spare Parts',
        field: 'subTaskIsSpareParts',
        minWidth: 200,
        valueFormatter: (params: any) => {
          if (params.value === true || params.value === 1) return 'Yes';
          if (params.value === false || params.value === 0) return 'No';
          return '';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Spare Part Code',
        field: 'subTaskSparePartCode',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Start Time',
        field: 'subTaskStartTime',
        minWidth: 200,
        valueFormatter: (params: any) =>
          params.value ? this.formatCellData(params.value, 'dateTime') : null,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'SP Request Time',
        field: 'subTaskSPRequestTime',
        minWidth: 200,
        valueFormatter: (params: any) =>
          params.value ? this.formatCellData(params.value, 'dateTime') : null,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'SP Received Time',
        field: 'subTaskSPReceivedTime',
        minWidth: 200,
        valueFormatter: (params: any) =>
          params.value ? this.formatCellData(params.value, 'dateTime') : null,
        headerValueGetter: this.localizeHeader.bind(this),
      },
    ];
  }
  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }
  editSubTask(element: any): void {
    this.subtaskFormMode = false;
    this.isViewMode = false;
    if (!element.externalVendorId && element.externalVendor) {
      // this.vendorMode = 'new';
      // this.vendorToggle = true;
      this.subTaskForm.patchValue({
        Id: element.id,
        woDetails: element.woDetails || '',
        responsible: element.responsibleId || '',
        targetDate: element.targetDate ? new Date(element.targetDate) : null,
        externalVendor: '',
        subTaskIsMachineBreakdown: element.subTaskIsMachineBreakdown === true ? 1 : element.subTaskIsMachineBreakdown === false ? 0 : '',
        subTaskIsSpareParts: element.subTaskIsSpareParts === true ? 1 : element.subTaskIsSpareParts === false ? 0 : '',
        subTaskSparePartCode: element.subTaskSparePartCode || '',
        subTaskSPRequestTime: element.subTaskSPRequestTime ? new Date(element.subTaskSPRequestTime) : null,
        subTaskSPReceivedTime: element.subTaskSPReceivedTime ? new Date(element.subTaskSPReceivedTime) : null,
        remarks: element.subTaskRemarks ? element.subTaskRemarks : null,
        // newVendorName: element.externalVendor
      });
      // Trigger validation
      this.setValidateSubTaskSparePartsCode();
    } else {
      this.vendorMode = 'existing';
      this.vendorToggle = false;
      this.subTaskForm.patchValue({
        Id: element.id,
        woDetails: element.woDetails || '',
        responsible: element.responsibleId || '',
        targetDate: element.targetDate ? new Date(element.targetDate) : null,
        externalVendor: element.externalVendorId || '',
        newVendorName: '',
        subTaskIsMachineBreakdown: element.subTaskIsMachineBreakdown === true ? 1 : element.subTaskIsMachineBreakdown === false ? 0 : '',
        subTaskIsSpareParts: element.subTaskIsSpareParts === true ? 1 : element.subTaskIsSpareParts === false ? 0 : '',
        subTaskSparePartCode: element.subTaskSparePartCode || '',
        subTaskSPRequestTime: element.subTaskSPRequestTime ? new Date(element.subTaskSPRequestTime) : null,
        subTaskSPReceivedTime: element.subTaskSPReceivedTime ? new Date(element.subTaskSPReceivedTime) : null,
        remarks: element.subTaskRemarks ? element.subTaskRemarks : null,
      });
      // Trigger validation
      this.setValidateSubTaskSparePartsCode();
    }

    const dialogRef = this.dialog.open(this.subTaskDialog, {
      height: 'auto',
      width: '90%',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe(() => {
      if (!this.isSubTaskSaved) {
        this.resetForm();
      }
      this.cdr.detectChanges();
    });
  }
  editRow(element: any) {
    this.editSubTask(element.rowData);
  }

  viewRow(element: any): void {
    this.viewSubTask(element.rowData);
  }

  viewSubTask(element: any): void {
    this.subtaskFormMode = false;
    this.isViewMode = true;
    if (!element.externalVendorId && element.externalVendor) {
      this.subTaskForm.patchValue({
        Id: element.id,
        woDetails: element.woDetails || '',
        responsible: element.responsibleId || '',
        targetDate: element.targetDate ? new Date(element.targetDate) : null,
        externalVendor: '',
        subTaskIsMachineBreakdown: element.subTaskIsMachineBreakdown === true ? 1 : element.subTaskIsMachineBreakdown === false ? 0 : '',
        subTaskIsSpareParts: element.subTaskIsSpareParts === true ? 1 : element.subTaskIsSpareParts === false ? 0 : '',
        subTaskSparePartCode: element.subTaskSparePartCode || '',
        subTaskSPRequestTime: element.subTaskSPRequestTime ? new Date(element.subTaskSPRequestTime) : null,
        subTaskSPReceivedTime: element.subTaskSPReceivedTime ? new Date(element.subTaskSPReceivedTime) : null,
        remarks: element.subTaskRemarks || null,

      });
    } else {
      this.vendorMode = 'existing';
      this.vendorToggle = false;
      this.subTaskForm.patchValue({
        Id: element.id,
        woDetails: element.woDetails || '',
        responsible: element.responsibleId || '',
        targetDate: element.targetDate ? new Date(element.targetDate) : null,
        externalVendor: element.externalVendorId || '',
        newVendorName: '',
        subTaskIsMachineBreakdown: element.subTaskIsMachineBreakdown === true ? 1 : element.subTaskIsMachineBreakdown === false ? 0 : '',
        subTaskIsSpareParts: element.subTaskIsSpareParts === true ? 1 : element.subTaskIsSpareParts === false ? 0 : '',
        subTaskSparePartCode: element.subTaskSparePartCode || '',
        subTaskSPRequestTime: element.subTaskSPRequestTime ? new Date(element.subTaskSPRequestTime) : null,
        subTaskSPReceivedTime: element.subTaskSPReceivedTime ? new Date(element.subTaskSPReceivedTime) : null,
        remarks: element.subTaskRemarks || null,

      });
    }

    // Disable all form fields for view mode
    this.subTaskForm.disable();

    const dialogRef = this.dialog.open(this.subTaskDialog, {
      height: 'auto',
      width: '90%',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe(() => {
      // Re-enable form fields after closing
      this.subTaskForm.enable();
      this.isViewMode = false;
      if (!this.isSubTaskSaved) {
        this.resetForm();
      }
      this.cdr.detectChanges();
    });
  }

  formatCellData(value: any, formatType: string): string {
    return this.userConfigService.formatField(value, formatType);
  }
}
